import React from 'react';
import logo from './logo.svg';
import './App.css';
import Places from "./containers/Places";
import Itinerary from "./containers/Itinerary";
import {applyMiddleware, createStore} from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import {Provider} from "react-redux";
import {View} from "react-native";

const store = createStore(rootReducer, applyMiddleware(thunk));

function App() {
  return (
      <Provider store={ store }>
        <View style={{flexDirection: 'row', height: '100%'}}>
          {/*
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <p>
              Edit <code>src/App.js</code> and save to reload.
            </p>
            <a
              className="App-link"
              href="https://reactjs.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn React
            </a>
          </header>
          */}
          <Itinerary />
          <Places />
        </View>
      </Provider>
  );
}

export default App;
